export var Swatches;
(function (Swatches) {
    Swatches["CYAN"] = "#00AEEF";
    Swatches["BLACK"] = "#000000";
    Swatches["WHITE"] = "#EFEFEF";
    Swatches["GREY"] = "#AAAAAA";
    Swatches["LIGHT_GREY"] = "#DADADA";
    Swatches["DARK_GREY"] = "#555555";
    Swatches["RED"] = "#DC3545";
})(Swatches || (Swatches = {}));
//# sourceMappingURL=swatches.js.map